var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompletedEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2039_5454",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2039_5454",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAAXNSR0IArs4c6QAABH1JREFUeF7tW11rFFcYfs7s7kzWKBrxUmIu/CgWa6NGC9IQ6kcSvSnG1DaKTbzRQFqxvfAfFBSMoE20vTEmrQpGb7zJ+tGGgKBNUoJQpWm01QvBG0E0ye58HTln90x2w0zDrLvuDDm5GU5mOHs+nvO87/uc9yVGyqBRNQpTNzEfn4RSSkEBEGA+PolEgESA5ADJAW7sn5rWMXh9GA//mAAhBLZlQ4kooXrGNBWrq1egvmUrTMPdynlagcSlu/jr3j988owmxF8Y22u3rET9/q2uVs7TCpw+epFPvvHzMiyvjMGygGgMSE5TaBoJRfvFcxM3+ifBkND+wxeufo4nAtgCsJ3vOL4Y1DJBIlEwIBCCULW7Tr7i4P3ubKs/BHR+08PPfPuxeHryYhFC9vzxxCs+j46TLf4Q0PltD185joAQ7rxAavepKY7kgiHg3wkDg4kkJt8EyypoGrB9VxyVVchBbN4I8OKAnu7XfPJBtAbxBQSHOhblcFTBOUCs6LqmWs6upq4jqqkwknrp2qqKkb6brpyVNwK8OECcqZq2BlDbBlEUUJuCKKSk7ZGLCVfOKjgHiBWtbtkGJRqBZZiIxKKwTauk7eELA4VFgBcHiDOVRkDpd14gb7T3lqvfUjQO+PirzwKx8wJ5BUeA5AAPT1ByQMa3lhwgOUD6ASW1+7P9joJbAekHzGEFpB8gYwEZC8hYIAhRoIwFMnpEUfUAOv0aqSkd2gIV3V0Kj7uDqge0HZyCyu4taBTqkqXIWxESfkD7kRRmZGGKcz+VceUlqLFA++Fk+hKLy8Iz481bFWYrynaeIYCt7LnzGkdAUP0Ar/HmfS/gICBzOXj+5zhXXoKqCXqN950QwHZeT9FQccDs8fpGgMMBHmdKckBA9QDJAcJqzeIsyQF+b4clB2T0AOkHeJwp6QcE9G5QxALSD5CxQG7s4tsTFHeDMhbIxNd+YoHxgWEYuoGPmmqd/IEH14aglmlYtXOjc6s8nhiBnkzx74Syw76LqTGsadzs3Du49ed1L/D+OKC1gUeFbpkh4pJiw4Edzvs/f7nN02yzrQf7juUabTzIvktnmoz23syKNtP9u/WXnZnCFoP1z8ZTdD2gt0/FdDKSkzO8cNlirG6ocXZ27MrvfOfZZGdrdtlK0tjl35xFEZkmbLJMa1y/r+5/+3vQPwRjKpkzjvKFCr5sdtcvCsYBz54pGByKYXKSlZgw4YWgosLG3mbbySfuv6pwQaZp78z/rvUrXFgq1HfsN16+JE62Wnk5Re2nBqqqaFrBKlYsIJQhxgkRNcZrjViOnuCI7PfZSlIx3ovfJ7zWBznKVdH8gKy08ZyVFhpc0N4LDfOdosFi72Qx+xcapm8OOPN9H0zDwu5GHZWVM2c5qDvthrz/nioYSDARFzh6+mt/2eKJX+/i0fDjUFWIeFW0fPjJKmxr3uIvW5yVmNy5eh9/jz7hSAhibvBclSxs5z/YtBJ1e2qgxVV/CMiuJGXwsiwbkYgSqieb9FwVsbJyVFaOyspRWTk6rytH3wLQMhBNVnJV4wAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedEvent);
export default __webpack_public_path__ + "static/media/completedEvent.864197fff777a05c83bb7f35eb45c26a.svg";
export { ForwardRef as ReactComponent };